<div class="cb-input-wrapper">
  <label *ngIf="label">{{label}}</label>
  <p-dropdown [autofocus]="autofocus" [placeholder]="placeholder ?? ''" [options]="options" [(ngModel)]="value"
    optionLabel="label" optionValue="value" (onChange)="onChange.emit($event)" [disabled]="disabled"
    [appendTo]="appendTo" [autoDisplayFirst]="false" [class.error]="error">
  </p-dropdown>
</div>
